import { render, staticRenderFns } from "./patientsPerDayNcNp.vue?vue&type=template&id=6e522554"
import script from "./patientsPerDayNcNp.vue?vue&type=script&lang=js"
export * from "./patientsPerDayNcNp.vue?vue&type=script&lang=js"
import style0 from "./patientsPerDayNcNp.vue?vue&type=style&index=0&id=6e522554&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports